// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_st-0";